import NotificationNavigator from '../utils/notifications/navigator';
import InitialNotificationParser from '../utils/notifications/notificationParser';

const notificationNavigator = new NotificationNavigator(new InitialNotificationParser());

export const listenForNotificationEvents = async (
  notifications,
  navigation,
  userProfileService,
) => {
  notificationNavigator.listenForEvents(
    notifications.manager,
    async (options) => {
      if (!options) {
        console.log('[listenForNotificationEvents] no options');
        return;
      }
      console.log('[listenForNotificationEvents Notification] got a notification in a running app, will call syncNow with splash screen',options);

      await notifications.syncNow();
      const ready = await notificationNavigator.getReadyNotificationState();
      console.log('[listenForNotificationEvents Notification] ready', ready);
      if (ready) {
        console.log('[listenForNotificationEvents] navigating to notification from running app', ready);
        if (options.type === 'notification') {
          console.log('[listenForNotificationEvents] handle notification with callback to running instance', ready);
          const manager = notifications.manager;
          await manager.handleNotificationById(ready.id, (e, details) => {
            console.log('[listenForNotificationEvents] navigate callback to just set the initial tab', details);
            userProfileService.markNotificationAsRead(ready.id);
            navigation.navigate('UserDashboard', details);
          });
        } else {
          console.log('[listenForNotificationEvents] unknown navigation type', options);
        }
      } else {
        console.warn('[listenForNotificationEvents] notification in running app is not ready', { options, ready });
      }
    },
  );
};
